var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"viewer"},[_c('button',{attrs:{"id":"downloadButton"}},[_vm._v("Descargar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }